<template>
    <span class="tag_item fs12 mr6 Text_Over" 
        :title="item.name" 
        :class="{action: !disabled}" 
        @mouseenter="mouseenter"
        @mouseleave="mouseleave"
        :style="{
            color: item.color, 
            borderColor: solidColorBag ? '#fff' : $utils.hexToRgb(item.color, hover ? 1 : 0.5),
            background: solidColorBag ? '#fff' : $utils.hexToRgb(item.color, hover ? 1 : 0.3),
            height:height,
            lineHeight:height
        }">
        {{item.name}}

        <span class="el-icon-close close" @click.stop="deleteFn"></span>
    </span>
</template>

<script>
    /**
     * ComponentName: 单个标签样式
     * Created Date:2022/5/7
     * Author: Nancy
     * Modify: shishuo·zhang 2022/5/16
     * 组件说明：
     * eg:
     *     <cl-tag :item="item"></cl-tag>
     */
    export default {
        name: 'cl-tag',
        data() {
            return {
                hover: false, // 是否hover
            };
        },
        props: {
            item: {
                type: Object,
                default: () => {}
            },
            disabled: {
                type: Boolean,
                default: true
            },
            height: {
                type: String,
                default: '21px'
            },
            solidColorBag: {
                type: Boolean,
                default: false
            },
        },

        methods: {
            // 删除标签
            deleteFn() {
                this.$emit('delete',this.item);
            },

            mouseenter() {
                if (this.disabled) return;
                this.hover = true;
            },

            mouseleave() {
                if (this.disabled) return;
                this.hover = false;
            }
        },
    }
</script>
<style lang='scss' scoped>
    .tag_item {
        display: inline-block;
        padding: 0 16px;
        border: 1px solid transparent;
        border-radius: 14px;
        position: relative;
        max-width: 100px;
        cursor: pointer;
        
        box-sizing: border-box;

        .close {
            position: absolute;
            top: 50%;
            right: 3px;
            transform: translateY(-45%);
            font-size: 12px;
            color: #fff;
            opacity: 0;
            cursor: pointer;
        }
    }

    .action {
        &:hover {
            color: #FFFFFF !important;

            .close {
                opacity: 1 !important;
            }
        }
    }
</style>